import DesignateModal from './DesignateModal';

export default DesignateModal;
